

export const PRIORITY_OPTIONS = [
    { text: 'High', value: 'high' },
    { text: 'Medium', value: 'medium' },
    { text: 'Low', value: 'low' }
]

export const SCROLL_DEBOUNCE_MS = 150
export const SCROLL_THRESHOLD = 0.85
export const TICKETS_PER_PAGE = 20
// Доска строит дерево действий целиком (действия всех линий), поэтому тянем их без пагинации
export const TICKET_ACTIONS_PER_PAGE = 200
export const HIGHLIGHT_DURATION_MS = 2000